import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as o, normalizeClass as n, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPowerDialerOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, i, u, _, a) {
  return d(), o("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--power-dialer-off"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Power Dialer Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    l("path", {
      d: "M.5 8.032a.5.5 0 1 0 0 1h4.045a.5.5 0 1 0 0-1H.5ZM.5 5.5a.5.5 0 0 0 0 1h2.087a.5.5 0 1 0 0-1H.5Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.363.458a.5.5 0 0 0-.708.707L2.46 2.968H.502a.5.5 0 1 0 .001 1H3.46L4.64 5.15l-.153.13a.65.65 0 0 0 .37 1.144L6 6.51l.496.496-.452 2.382c-.117.618.624 1.025 1.083.596L8.34 8.849l2.316 2.316a.5.5 0 1 0 .707-.707l-10-10Zm5.99 7.404-.126.66.406-.38-.28-.28Zm2.712-6.057c.115-.614-.616-1.021-1.077-.6L6.481 3.49a.5.5 0 0 0 .674.739l1.734-1.582-.412 2.192a.65.65 0 0 0 .614.77l1.302.051-.989.862a.5.5 0 1 0 .657.754l1.654-1.441a.65.65 0 0 0-.402-1.14l-1.778-.07.53-2.821Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, f);
}
const L = /* @__PURE__ */ s(c, [["render", m]]);
export {
  L as default
};
//# sourceMappingURL=power-dialer-off.js.map
